import { define, auto } from 'type-r'
import { store } from '../models/store.js'
import ChartView from './chart_view.js'
import { makeLine } from '../util.js'
import type * as Highcharts from 'highcharts'

import HighchartsTheme from './ohlc_theme.js'


@define
export default class OhlcComponent extends ChartView {
    @auto(null) declare chart: any;

    initialize() {
        super.initialize();
        this.listenTo(this, "change:dd", this.render);
    }

    protected get choiceValue(): number { return 0; }

    protected onResized(): void {
        if (this.chart) {
            const el = $(this.el);
            this.chart.setSize(el.width()!, el.height()!, false);
        }
    }

    protected onCpnChanging(): void {
        if (this.chart != null)
            this.chart.showLoading();
    }

    protected fetchParams(): Record<string, any> {
        return { ...super.fetchParams(), fj: store.token, type: 'checkohlc', maxdt: 0 };
    }

    render(): void {
        const cc = $(this.el).height()!;

        if (this.chart != null && this.chart.destroy)
            this.chart.destroy();

        const dd = this.dd;
        const ss: any[] = [];
        ss.push({ type: 'candlestick', name: `FNMA ${store.selCpn}`, data: dd });
        ss.push({ type: 'line', name: '10 Day Moving Average', data: this.CustomSimpleMovingAverage(dd, 10) });
        ss.push({ type: 'line', name: '25 Day Moving Average', data: this.CustomSimpleMovingAverage(dd, 25) });
        ss.push({ type: 'line', name: '50 Day Moving Average', data: this.CustomSimpleMovingAverage(dd, 50) });
        ss.push({ type: 'line', name: '100 Day Moving Average', data: this.CustomSimpleMovingAverage(dd, 100) });
        ss.push({ type: 'line', name: '200 Day Moving Average', data: this.CustomSimpleMovingAverage(dd, 200) });

        if (store.rr != null) {
            ss.push({ type: 'line', name: 'Support', data: makeLine(store.rr.support, dd), color: '#191' });
            ss.push({ type: 'line', name: 'Resistance', data: makeLine(store.rr.resistance, dd), color: '#911' });
        }
        window.Highcharts.theme = HighchartsTheme;
        this.chart = new window.Highcharts.StockChart({
            chart: {
                renderTo: this.el,
                height: cc,
            },
            rangeSelector: { selected: 0 },
            tooltip: { valueDecimals: 2 },
            navigator: { enabled: true },
            series: ss
        });
    }

    findCandleElement(dt: number): number {
        const ss = this.chart.series[0].data;
        for (let x in ss) {
            if (ss[x].x == dt) {
                return parseInt(x);
            }
        }
        return -1;
    }

    updateCandleData(data: any): void {
        const dd = (window as any).dd;
        if (dd && dd != null && this.visible) {
            for (let x = 0; x < dd.length; x++) {
                const existing = this.findCandleElement(dd[x][0]);
                if (existing != -1) {
                    this.chart.series[0].data[existing].update(dd[x], false, false);
                } else {
                    this.chart.series[0].addPoint(dd[x], false, false);
                    window.location.reload();
                }
                if (store.rr != null) {
                    // Support/resistance handled via makeLine
                }
                if (store.rr && store.rr.support && this.chart.series.length >= 7) {
                    for (let y in this.chart.series[6].data)
                        this.chart.series[6].data[y].update([this.chart.series[6].data[y].x, store.rr.support], false, false);
                    for (let y in this.chart.series[7].data)
                        this.chart.series[7].data[y].update([this.chart.series[7].data[y].x, store.rr.resistance], false, false);
                }
                this.updateMovAvg(this.CustomSimpleMovingAverage(this.chart.series[1], 10), 1);
                this.updateMovAvg(this.CustomSimpleMovingAverage(this.chart.series[2], 25), 2);
                this.updateMovAvg(this.CustomSimpleMovingAverage(this.chart.series[3], 50), 3);
                this.updateMovAvg(this.CustomSimpleMovingAverage(this.chart.series[4], 100), 4);
                this.updateMovAvg(this.CustomSimpleMovingAverage(this.chart.series[5], 200), 5);
            }
            this.chart.redraw();
        }
    }

    CustomSimpleMovingAverage(ss: any[], cnt: number): any[] {
        let lastDt = 0;
        const elems = new (window as any).Queue();
        const movAvg: any[] = [];
        for (let i = 0; i < ss.length; i++) {
            if (ss[i][0] < lastDt) continue;
            lastDt = ss[i][0];
            elems.enqueue(ss[i][4]);
            while (elems.getLength() > cnt) {
                elems.dequeue();
            }
            let total = 0;
            for (let j = 0; j < elems.getLength(); j++) {
                total += elems.getItem(j);
            }
            total /= elems.getLength();
            movAvg.push([ss[i][0], total]);
        }
        return movAvg;
    }

    updateMovAvg(pts: any[], idx: number): void {
        for (let pp = 0; pp < pts.length; pp++) {
            if (this.chart.series[idx].data.length > pp)
                this.chart.series[idx].data[pp].update(pts[pp], false, false);
            else
                this.chart.series[idx].addPoint(pts[pp], false, false);
        }
    }
}
